import { Route } from "react-router-dom";
import AbpnSpinner from "../Shared/Components/AbpnSpinner";
import { AuthConsumer } from "./AuthProvider";

export const StaffOnlyRoute = ({ component, ...rest }: any) => {

    const renderFn = (Component :any) => (props: any) => (
        <AuthConsumer>
            {({ isAuthenticated, staffSigninRedirect }) => {
                if (!!Component && isAuthenticated()) {
                    return <Component {...props} />;
                } else {
                    staffSigninRedirect();
                    return <AbpnSpinner/>;
                }
            }}
        </AuthConsumer>
    );

    return <Route {...rest} render={renderFn(component)} />;
}